// extracted by mini-css-extract-plugin
export default {"username":"UserName_username__fZOcA","verifiedSvg":"UserName_verifiedSvg__0z9Tj"};